var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStacksHeart = function SvgIconStacksHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15 6.225 1.254 9.492c-.34.196-.34.82 0 1.016l5.894 3.267c.54.3 1.161.3 1.702 0l5.894-3.267c.34-.196.34-.82 0-1.016L8.85 6.225c-.54-.3-1.161-.3-1.702 0Z",
    fill: "url(#icon-stacks-heart_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15 2.224 1.254 5.5c-.34.195-.34.818 0 1.013L7.15 9.776c.54.299 1.161.299 1.702 0l5.894-3.263c.34-.195.34-.818 0-1.013L8.85 2.224a1.726 1.726 0 0 0-1.702 0Z",
    fill: "#006DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-stacks-heart_svg__a",
    x1: 8,
    y1: 7.152,
    x2: 8,
    y2: 14.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00299C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073E6"
  })))));
};
export default SvgIconStacksHeart;